import React, { useState, useEffect } from 'react';
import AdminTable from 'common/AdminTable';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { getRequest, patchRequest, deleteRequest } from 'apis/ApiInstence';
import { useNavigate } from 'react-router-dom';

const ServiceMenList = () => {
  const [serviceMen, setServiceMen] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentMan, setCurrentMan] = useState(null);
  const navigate = useNavigate();

  const loadInitialData = async () => {
    const res = await getRequest(`servicemen`, true);
    if (res?.status) {
      setServiceMen(res?.data)
    } else {
      toast('Failed to update QR!')
    }
  };
  useEffect(() => {
    loadInitialData()
  }, [])

  const handleEditClick = (man) => {
    setCurrentMan(man);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentMan(null);
  };

  const handleSave = async () => {
    const res = await patchRequest(`servicemen/admin/${currentMan?.id}`, {
      ...currentMan
    });
    if (res?.status) {
      loadInitialData()
    } else {
      toast('Failed to update QR!')
    }
    toast.success("Service Man Updated Successfully!");
    handleCloseModal();
  };

  const handleRemove = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This serviceman will be deleted permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setServiceMen(serviceMen.filter((m) => m.id !== id));
        await deleteRequest(`servicemen/${id}`,true);
        Swal.fire("Deleted!", "The serviceman has been removed.", "success");
      }
    });
  };

  const tableHeaders = [
    { Header: "ID", accessor: "id" },
    {
      Header: "Image", accessor: "image", Cell: ({ row }) => (
        <img
          src={`${process.env.REACT_APP_BACKEND}asserts/serviceman/${row.original.user_image}` || 'https://via.placeholder.com/50'}
          alt="Service Man"
          style={{ width: '50px', height: '50px', borderRadius: '50%' }}
        />
      ),
    },
    { Header: "Full Name", accessor: "name" },
    { Header: "Mobile", accessor: "mobile" },
    { Header: "City", accessor: "city" },
    { Header: "Joining Date", accessor: "created_at" },
    { Header: "Total Rating", accessor: "rating_count" },
    { Header: "Average Rating / 5", accessor: "avg_rating" },


    {
      Header: "Active",
      accessor: "status",
      Cell: ({ row }) => (
        <span
          className={
            row.original.is_active === "YES"
              ? "badge badge-success"
              : "badge badge-danger"
          }
        >
          {row.original.is_active}
        </span>
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <>
          <button
            className="btn removebtn mx-1 my-1"
            onClick={() => handleRemove(row.original.id)}
          >
            Remove
          </button>
          <button
            className="btn editbtn mx-1 my-1"
            onClick={() => handleEditClick(row.original)}
          >
            Edit
          </button>
          <button
            className="btn editbtn mx-1 my-1"
            onClick={() => navigate('/servicemanwork/' + row.original.id)}
          >
            Work
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="container-fluid mt-5 ">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Service Men List</h4>
        </div>
        {serviceMen.length > 0 && (
          <AdminTable tableHeaders={tableHeaders} tableData={serviceMen} />
        )}
      </div>

      {/* Edit Modal */}
      {showModal && currentMan && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Service Man</h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label htmlFor='status'>Status</label>
                    <select
                      defaultValue={currentMan.is_active}
                      onChange={(e) =>
                        setCurrentMan({
                          ...currentMan,
                          is_active: e.target.value,
                        })
                      }
                      className="form-control"
                      value={currentMan.is_active || "YES"}
                    >
                      <option value="YES">Active</option>
                      <option value="NO">Inactive</option>
                    </select>


                  </div>
                  <div className="form-group">
                    <label htmlFor='fullname'>Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currentMan.name}
                      onChange={(e) =>
                        setCurrentMan({
                          ...currentMan,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor='mobile'>Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currentMan.mobile}
                      onChange={(e) =>
                        setCurrentMan({
                          ...currentMan,
                          mobile: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor='email'>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={currentMan.email}
                      onChange={(e) =>
                        setCurrentMan({
                          ...currentMan,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor='city'>City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currentMan.city}
                      onChange={(e) =>
                        setCurrentMan({ ...currentMan, city: e.target.value })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor='service_category'>Service Category</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currentMan.service_category}
                      onChange={(e) =>
                        setCurrentMan({
                          ...currentMan,
                          service_category: e.target.value,
                        })
                      }
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceMenList;
